import { AppDate } from '../envTypes';
import { PopClip } from './popclip';
import { PopStoreUserAccessLevel } from './creator-subscription';
import { FromTemplate, ModelBase } from './base';

export enum SeriesLabelFormat {
  Short = 'SHORT',
  Long = 'LONG',
}

export enum SeriesChapterLabelFormat {
  Ch = 'CH',
  Chapter = 'CHAPTER',
}

export enum SeriesElementSortingStrategy {
  MostRecentFirst = 'MOST_RECENT_FIRST',
  MostRecentLast = 'MOST_RECENT_LAST',
  Custom = 'CUSTOM',
}

export enum SeriesType {
  Default = 'DEFAULT',
  Course = 'COURSE',
  SubSeries = 'SUB_SERIES',
}

export enum SeriesElementType {
  PopClip = 'POP_CLIP',
}

export interface Series extends ModelBase, FromTemplate {
  name: string;
  slug: string;
  type?: SeriesType;
  description?: string;
  parentId?: string;

  /*** episode settings ***/
  labelFormat?: SeriesLabelFormat;
  showLabel?: boolean;

  /*** chapter settings ***/
  hasChapter?: boolean;
  chapterLabelFormat?: SeriesChapterLabelFormat;

  /*** marketing banner settings ***/
  mobileBannerImage?: string;
  desktopBannerImage?: string;

  sort: number;
  elementSortingStrategy?: SeriesElementSortingStrategy;
  archived: boolean;

  /*** course price settings ***/
  standaloneSale?: boolean;
  price?: number;
  discountPrice?: number;
  discountEnabled?: boolean;
  discountStartDate?: AppDate;
  discountEndDate?: AppDate;

  listingId?: string;
  accessLevel?: PopStoreUserAccessLevel;

  /**
   * @deprecated
   */
  popClipIds: string[];
}

export enum SeriesElementAccessLevel {
  ALL = 'all',
  SUBSCRIBER = 'subscriber',
  FAN = 'fan',
  VIP = 'vip',
}

export enum SeriesElementContentType {
  Feed = 'FEED',
  Episode = 'EPISODE',
  Teaser = 'TEASER',
  Promo = 'PROMO',
  Sponsored = 'SPONSORED',
}

export type SeriesElementBase = ModelBase & {
  accessLevel?: SeriesElementAccessLevel;
  pinned?: boolean;
  sort: number;
  rootSeriesId: string;
  startOfChapter?: boolean;
};

export type SeriesElement = SeriesElementBase & {
  type: SeriesElementType.PopClip;
  popClip: PopClip;
  contentType?: SeriesElementContentType;
};
